import { render, staticRenderFns } from "./PrestacaoContasDashboard.vue?vue&type=template&id=1814fca2&"
import script from "./PrestacaoContasDashboard.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContasDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports